import { autoserialize } from 'cerialize';

export class StandardDonationItem implements IStandardDonationItem {
  @autoserialize id?: string;
  @autoserialize name?: string;
  @autoserialize type?: string;
  @autoserialize source_item_id?: string;
  @autoserialize version?: string;
  @autoserialize price?: number;
  @autoserialize value?: number;
  @autoserialize small?: number;
  @autoserialize medium?: number;
  @autoserialize large?: number;
  @autoserialize xlarge?: number;
  @autoserialize recycling?: number;
  @autoserialize item_recycling?: number;
  @autoserialize specialty?: number;
  @autoserialize disassembly?: number;
  @autoserialize restricted?: boolean;
  @autoserialize guaranteed?: boolean;
  @autoserialize item_value?: number;
  @autoserialize icon_url?: string;
  @autoserialize photo_url?: string;

  constructor(payload?: IStandardDonationItem) {
    this.id = payload?.id?.toString();
    this.name = payload?.name;
    this.type = payload?.type;
    this.source_item_id = payload?.source_item_id?.toString();
    this.version = payload?.version;
    this.price = payload?.price;
    this.value = payload?.value;
    this.small = payload?.small ?? 0;
    this.medium = payload?.medium ?? 0;
    this.large = payload?.large ?? 0;
    this.xlarge = payload?.xlarge ?? 0;
    this.recycling = payload?.recycling ?? 0;
    this.item_recycling = payload?.item_recycling ?? 0;
    this.specialty = payload?.specialty ?? 0;
    this.disassembly = payload?.disassembly ?? 0;
    this.restricted = payload?.restricted;
    this.guaranteed = payload?.guaranteed;
    this.item_value = payload?.item_value ?? 0;
    this.icon_url = payload?.icon_url;
    this.photo_url = payload?.photo_url;
  }
}

export interface IStandardDonationItem {
  id?: string;
  name?: string;
  type?: string;
  source_item_id?: string;
  version?: string;
  price?: number;
  value?: number;
  small?: number;
  medium?: number;
  large?: number;
  xlarge?: number;
  recycling?: number;
  item_recycling?: number;
  specialty?: number;
  disassembly?: number;
  restricted?: boolean;
  guaranteed?: boolean;
  item_value?: number;
  icon_url?: string;
  photo_url?: string;
}
